import { DayOfWeek } from '../../enums/DayOfWeek';
import { EmployeePositionId } from '../employee/Employee';

/**
 * A class that describes an employee being absent full day in the rota.
 */
export class RotaFullDayAbsenceAssignment {
  employeePositionId: EmployeePositionId;
  dayOfWeek: DayOfWeek;

  /**
   * @param employeePositionId the identifier of the employee and position.
   * @param dayOfWeek the day of week of the assignment.
   */
  constructor(
    employeePositionId: EmployeePositionId,
    dayOfWeek: DayOfWeek
  ) {
    this.employeePositionId = employeePositionId;
    this.dayOfWeek = dayOfWeek;
  }

  hasEqualEmployeeAndDay(employeePositionId: EmployeePositionId, dayOfWeek: DayOfWeek): boolean {
    return this.employeePositionId.value === employeePositionId.value && this.dayOfWeek === dayOfWeek;
  }
}
